import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FolderService } from '../../services/folder.service';

@Component({
  selector: 'app-create-folder-modal',
  templateUrl: './create-folder-modal.component.html',
  styleUrls: ['./create-folder-modal.component.scss']
})
export class CreateFolderModalComponent implements OnInit {

  folderName = '';
  folderData
  isNotify = false
  isLoading = false
  // data;

  constructor(public _folderService: FolderService, public dialogRef: MatDialogRef<CreateFolderModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.folderData = this.data
    console.log("this.data=====>>>", typeof this.folderData.folderId, this.data)
  }
  save() {
    console.log('FOLDER NAME IS', this.folderName);

    let newFolder = {}
    if (this.folderName) { newFolder['title'] = this.folderName }
    if (this.folderData && this.folderData.folderId && typeof this.folderData.folderId == 'string') { newFolder['parent'] = this.folderData.folderId }
    if (this.isNotify) newFolder['isNotify'] = this.isNotify
    if (this.data.refModule == 'labourjob') newFolder['labourDocumentId'] = this.folderData.labourDocumentId
    newFolder['refModule'] = this.data.refModule
    console.log("New folder", newFolder, this.isNotify);
    if (this.folderName != '') {
      this.isLoading = true
      this._folderService.createFolder(newFolder).subscribe(data => {
        this.data = data;
        console.log("Create Successfully", data);
        this.isLoading = false
        this.dialogRef.close(data);
      }, err => {
        console.log('Error', err.msg);
        this.isLoading = false
        this.dialogRef.close(null);
      })
    }
    else {
      this.isLoading = false
      console.log("INVALID");
    }
  }

}
